import { render, staticRenderFns } from "./ListaProveedores.vue?vue&type=template&id=54749550&"
import script from "./ListaProveedores.vue?vue&type=script&lang=js&"
export * from "./ListaProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports